/**
 * status types for group sessions
 */
export const GROUP_SESSION_STATUS_TYPES = Object.freeze({
  booked: "booked",
  cancelled: "cancelled",
  undefined: "undefined",
} as const);

export type TGroupSessionStatusTypesKey =
  keyof typeof GROUP_SESSION_STATUS_TYPES;
